(function(){
  'use strict';

  // ============ Mega menu (desktop hover) ============
  var navLinks = document.querySelectorAll('[data-sm-nav-link]');
  var megaPanels = {};
  document.querySelectorAll('[data-sm-mega-panel]').forEach(function(p){
    megaPanels[p.getAttribute('data-sm-mega-panel')] = p;
  });
  var closeTimer = null;
  function openMega(id){
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    Object.keys(megaPanels).forEach(function(k){
      megaPanels[k].classList.toggle('open', k === id);
      megaPanels[k].setAttribute('aria-hidden', k === id ? 'false' : 'true');
    });
    navLinks.forEach(function(l){ l.classList.toggle('mega-open', l.getAttribute('data-mega') === id); });
  }
  function closeMega(){
    Object.keys(megaPanels).forEach(function(k){ megaPanels[k].classList.remove('open'); megaPanels[k].setAttribute('aria-hidden','true'); });
    navLinks.forEach(function(l){ l.classList.remove('mega-open'); });
  }
  function scheduleClose(){
    if (closeTimer) clearTimeout(closeTimer);
    closeTimer = setTimeout(closeMega, 220);
  }
  navLinks.forEach(function(link){
    var id = link.getAttribute('data-mega');
    if (!id || !megaPanels[id]) return;
    link.addEventListener('mouseenter', function(){ if (window.matchMedia('(min-width: 981px)').matches) openMega(id); });
    link.addEventListener('mouseleave', scheduleClose);
  });
  Object.values(megaPanels).forEach(function(p){
    p.addEventListener('mouseenter', function(){ if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; } });
    p.addEventListener('mouseleave', scheduleClose);
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeMega(); });

  // ============ Mobile drawer ============
  var burger = document.querySelector('[data-sm-burger]');
  var navLinksContainer = document.querySelector('[data-sm-nav-links]');
  var navScrim = document.querySelector('[data-sm-nav-scrim]');
  function setDrawer(open){
    if (navLinksContainer) navLinksContainer.classList.toggle('open', open);
    if (navScrim) navScrim.classList.toggle('show', open);
    if (burger) burger.classList.toggle('open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  if (burger) burger.addEventListener('click', function(){ setDrawer(!navLinksContainer.classList.contains('open')); });
  if (navScrim) navScrim.addEventListener('click', function(){ setDrawer(false); });

  // Mobile mega expand
  navLinks.forEach(function(link){
    if (!link.getAttribute('data-mega')) return;
    var anchor = link.querySelector('a');
    if (!anchor) return;
    anchor.addEventListener('click', function(e){
      if (window.matchMedia('(max-width: 980px)').matches) {
        e.preventDefault();
        link.classList.toggle('mobile-expanded');
      }
    });
  });

  // ============ Cart sheet ============
  var sheet = document.querySelector('[data-sm-cart-sheet]');
  var sheetScrim = document.querySelector('[data-sm-sheet-scrim]');
  function openSheet(payload){
    if (!sheet) return;
    if (payload) {
      var n = sheet.querySelector('[data-sm-sheet-name]');
      var s = sheet.querySelector('[data-sm-sheet-spec]');
      var p = sheet.querySelector('[data-sm-sheet-price]');
      var t = sheet.querySelector('[data-sm-sheet-thumb]');
      if (n) n.textContent = payload.title || '';
      if (s) s.textContent = payload.spec || '';
      if (p) p.textContent = payload.price || '';
      if (t) {
        if (payload.teikning && payload.teikning.nodeType) {
          /* Teikning síðunnar sjálfrar (DOM-hnútur, ekki texti) */
          t.textContent = '';
          t.appendChild(payload.teikning);
        } else if (payload.image) {
          /* DOM-hnútar í stað innerHTML (QA18 3, 20.10): engin slóð eða titill fer í HTML-streng */
          var mynd = document.createElement('img');
          mynd.src = payload.image;
          mynd.alt = '';
          mynd.style.cssText = 'width:100%;height:100%;object-fit:cover;border-radius:8px';
          t.textContent = '';
          t.appendChild(mynd);
        } else {
          var inni = document.createElement('span');
          inni.className = 'cart-sheet-thumb-inner';
          inni.textContent = payload.title || '';
          t.textContent = '';
          t.appendChild(inni);
        }
      }
    }
    sheet.classList.add('open');
    sheet.setAttribute('aria-hidden','false');
    if (sheetScrim) sheetScrim.classList.add('show');
    if (payload && payload.fokus) {
      var fyrsti = sheet.querySelector('a[href], button');
      if (fyrsti) setTimeout(function(){ fyrsti.focus({ preventScroll: true }); }, 60);
    }
  }
  function closeSheet(){
    if (!sheet) return;
    sheet.classList.remove('open');
    sheet.setAttribute('aria-hidden','true');
    if (sheetScrim) sheetScrim.classList.remove('show');
  }
  document.querySelectorAll('[data-sm-sheet-close]').forEach(function(b){ b.addEventListener('click', closeSheet); });
  if (sheetScrim) sheetScrim.addEventListener('click', closeSheet);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeSheet(); });
  /* Fókusgildra meðan körfugluggi er opinn (QA7 F4, 20.10): Tab hringar innan gluggans, aria-modal á gluggann sjálfan */
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Tab' || !sheet || !sheet.classList.contains('open')) return;
    var f = sheet.querySelectorAll('a[href], button:not([disabled])');
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (!sheet.contains(document.activeElement)) { e.preventDefault(); a.focus(); }
    else if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  });

  /* Sameiginlegt fyrir síðuskriftur sem bæta í körfu með eigin fetch
     (formið ber þá ekkert action og hlustarinn hér fyrir neðan grípur
     það ekki). Fyrsti notandi: sm-husnumer.js.
       SMKarfa.opna({ title, spec, price, image | teikning, fokus })
       SMKarfa.loka()
       SMKarfa.fjoldi()  sækir /cart.js, setur töluna í hausnum og
                         skilar körfunni (Promise) */
  function cartCount(){
    return fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var count = document.querySelector('[data-sm-cart-count]');
        if (count && cart && typeof cart.item_count === 'number') count.textContent = cart.item_count;
        return cart;
      });
  }
  window.SMKarfa = { opna: openSheet, loka: closeSheet, fjoldi: cartCount };

  // Intercept add-to-cart forms
  /* Skrár sem fylgja línu (snippets/sm-skra.liquid + assets/sm-skra.js):
     vanti skrá sem á að fylgja stoppar sendingin hér og reiturinn segir hvað
     vantar. Beiðnin er multipart FormData, svo skráin fer í sömu ferð og
     varan. Hnappurinn heldur innra HTML (örinni) þegar hann er endurstilltur. */
  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    if (form.__smSendir) return; /* farsímastikan getur sent aftur á meðan skrá er á leiðinni */
    var skra = window.SMSkra;
    if (skra && !skra.athuga(form)) return;
    var btn = form.querySelector('button[type=submit]');
    var orig = btn ? btn.innerHTML : '';
    var pdpRot = form.closest('[data-sm-pdp-root]');
    var mBtn = pdpRot ? pdpRot.querySelector('[data-sm-mobile-add]') : null;
    var mOrig = mBtn ? mBtn.innerHTML : '';
    var formData = new FormData(form);
    /* Tómir textareitir fara ekki í pöntunina sem tóm lína */
    var tomir = [];
    formData.forEach(function(v, k){ if (/^properties\[/.test(k) && typeof v === 'string' && !v.trim()) tomir.push(k); });
    tomir.forEach(function(k){ formData.delete(k); });
    var skrar = skra ? skra.fylla(formData, form) : 0;
    var bidTexti = skrar ? 'Sendi skrá...' : 'Bæti við...';
    form.__smSendir = true;
    if (btn) { btn.disabled = true; btn.textContent = bidTexti; }
    if (mBtn) { mBtn.disabled = true; mBtn.textContent = bidTexti; }
    fetch(window.routes.cart_add_url, { method: 'POST', body: formData, headers: { Accept: 'application/json' }})
      .then(function(r){
        if (r.status === 413) {
          var stor = new Error('413');
          stor.skra = 'Skráin er of stór til að senda. Hún má mest vera ' + (skra ? skra.hamarkTexti(form) : '19 MB') + '.';
          throw stor;
        }
        return r.json();
      })
      .then(function(item){
        if (item.status && item.status >= 400) {
          alert(item.description || item.message || 'Ekki tókst að bæta í körfu');
          return;
        }
        return fetch(window.routes.cart_url + '.js').then(function(r){ return r.json(); }).then(function(cart){
          var count = document.querySelector('[data-sm-cart-count]');
          if (count) count.textContent = cart.item_count;
          /* Línan eins og hún er í körfunni: rétt verð (fjöldi x verð eftir afslátt) og mynd afbrigðisins */
          var line = null;
          (cart.items || []).forEach(function(i){ if (!line && item.key && i.key === item.key) line = i; });
          var src = line || item;
          var price = src.final_line_price || src.final_price || src.price || 0;
          var formatted = String(Math.round(price/100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr.'; // toLocaleString('is-IS') skilar kommu an islenskra stadfaerslugagna
          openSheet({
            title: src.product_title || src.title,
            spec: src.variant_title && src.variant_title !== 'Default Title' ? src.variant_title : '',
            price: formatted,
            image: src.image || (src.featured_image && src.featured_image.url) || ''
          });
        });
      })
      .catch(function(err){
        if (!(err && err.skra)) console.error(err);
        if (skrar && skra && skra.villa(form, (err && err.skra) || 'Ekki tókst að senda skrána. Athugaðu nettenginguna og reyndu aftur.')) return;
        alert('Villa kom upp');
      })
      .finally(function(){
        form.__smSendir = false;
        if (btn) { btn.disabled = false; btn.innerHTML = orig; }
        if (mBtn) { mBtn.disabled = false; mBtn.innerHTML = mOrig; }
      });
  });

  // ============ FAQ accordion ============
  document.querySelectorAll('[data-sm-faq]').forEach(function(item){
    var q = item.querySelector('.faq-q');
    if (!q) return;
    q.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false');
    q.addEventListener('click', function(){ var opid = item.classList.toggle('open'); q.setAttribute('aria-expanded', opid ? 'true' : 'false'); });
  });

})();
